import styled, { css } from 'styled-components';
import { animations } from '../animations';

export const StyledAccordion = styled.div``;

export const AccordionSummary = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 0 ${(props) => props.theme.spacing['8px']} 0 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};

  &:hover {
    cursor: pointer;
  }
`;

export const IconContainer = styled.div<{ open: boolean }>`
  transition: transform 0.3s ease;
  transform: rotate(${({ open }) => (open ? '0deg' : '180deg')});
  position: relative;
  top: 2px;
`;

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
`;

export const ContentContainer = styled.div``;

export const AccordionDetails = styled.div<{ open: boolean }>`
  transition: height 0.3s, opacity 0.3s, padding 0.3s;
  opacity: 0;

  ${({ open }) =>
    open &&
    css`
      height: 100%;
      opacity: 1;
    `}
`;

export const OpenContent = styled.div<{ open?: boolean }>`
  transition: height 0.3s, opacity 0.3s, padding 0.3s;
`;

export const ClosedContent = styled.div<{ open?: boolean }>`
  opacity: 0;
  animation: ${animations.fadeIn} 0.2s ease forwards;
  animation-delay: 0.3s;
  cursor: pointer;
`;
